(function() {
  'use strict';

  /* ─── 1. Sticky pill bar — active tracking via IntersectionObserver ─── */
  var pills = document.querySelectorAll('.avora-collist__pill[data-dept]');
  var sections = document.querySelectorAll('.avora-collist__dept[data-dept]');

  if (sections.length && pills.length) {
    var headerH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 64;
    var pillBar = document.querySelector('.avora-collist__nav');
    var pillBarH = pillBar ? pillBar.offsetHeight : 50;
    var offset = headerH + pillBarH + 20;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var id = entry.target.getAttribute('data-dept');
          pills.forEach(function(p) {
            p.classList.toggle('avora-collist__pill--active', p.getAttribute('data-dept') === id);
          });

          /* Scroll active pill into view */
          var activePill = document.querySelector('.avora-collist__pill--active');
          if (activePill && pillBar) {
            var container = pillBar.querySelector('.avora-collist__pills');
            if (container) {
              var pillLeft = activePill.offsetLeft - container.offsetLeft;
              var scrollTo = pillLeft - container.clientWidth / 2 + activePill.offsetWidth / 2;
              container.scrollTo({ left: scrollTo, behavior: 'smooth' });
            }
          }
        }
      });
    }, {
      rootMargin: '-' + offset + 'px 0px -60% 0px',
      threshold: 0
    });

    sections.forEach(function(s) { observer.observe(s); });

    /* ─── 2. Smooth scroll on pill click ─── */
    pills.forEach(function(pill) {
      pill.addEventListener('click', function(e) {
        e.preventDefault();
        var id = pill.getAttribute('data-dept');
        var target = document.querySelector('.avora-collist__dept[data-dept="' + id + '"]');
        if (!target) return;

        var top = target.getBoundingClientRect().top + window.scrollY - offset + 10;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
  }

  /* ─── 3. Scroll reveal animation ─── */
  var revealEls = document.querySelectorAll('.avora-collist__dept, .avora-collist__more');

  if (revealEls.length) {
    var revealObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('avora-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '0px 0px -60px 0px',
      threshold: 0.05
    });

    revealEls.forEach(function(el) { revealObserver.observe(el); });
  }
})();
